import Component from '@glimmer/component';

import ReportsEditorSlideSettingsTypeBoard from 'webapp/components/reports/editor/slide-settings/type-board';
import ReportsEditorSlideSettingsTypeText from 'webapp/components/reports/editor/slide-settings/type-text';
import ReportsMasterDateRangeSwitch from 'webapp/components/reports/master-date-range-switch';

import type Report from 'webapp/models-custom/report';
import type ReportSlide from 'webapp/models-custom/report-slide';

interface ReportsEditorSlideSettingsComponentInterface {
	Args: {
		model: ReportSlide;
		onChange: () => void;
		onDuplicate: () => void;
		onRemove: () => void;
	};
}

export default class ReportsEditorSlideSettingsComponent extends Component<ReportsEditorSlideSettingsComponentInterface> {
	get report(): Report {
		return this.args.model.report!;
	}

	get isFirstSlide(): boolean {
		const report = this.report;

		return report.sortedSlides[0]!.id === this.args.model.id;
	}

	get isMasterDateRangeSwitchShown(): boolean {
		return (
			!!this.report.slides.some(
				(slide) => slide.hasFragmentsWithMetricData || slide.isTypeBoard,
			) && this.isFirstSlide
		);
	}

	<template>
		<div class="report_slide_settings type-{{if @model.isTypeBoard 'board' 'text'}}">

			{{#if @model.report.isTemplate}}
				<div class="template-label"></div>
			{{/if}}

			<div class="report_slide_settings_content">
				{{#if @model.isTypeBoard}}
					<ReportsEditorSlideSettingsTypeBoard
						@model={{@model}}
						@onChange={{@onChange}}
						@onDuplicate={{@onDuplicate}}
						@onRemove={{@onRemove}}
					/>
				{{else}}
					<ReportsEditorSlideSettingsTypeText
						@model={{@model}}
						@onChange={{@onChange}}
						@onDuplicate={{@onDuplicate}}
						@onRemove={{@onRemove}}
					/>
				{{/if}}
			</div>

			{{#if this.isMasterDateRangeSwitchShown}}
				<div class="report_slide_settings_date_range">
					<ReportsMasterDateRangeSwitch
						@model={{this.report}}
						@customLabel="Report date range"
					/>
				</div>
			{{/if}}
		</div>
	</template>
}
